import React, { ChangeEvent, useState, useEffect } from 'react'
import i18n from '../../translate/i18n';
import './styles.css'
import DataTable from 'react-data-table-component';

// ICONS
import { FaSearch } from 'react-icons/fa';

const customStyles = {
  headRow: {
    style: {
      color: '#FFD35B',
      background: '#00537A',
    },
  },
  table: {
    style: {
      minHeight: '400px'
    }
  }
}

//COMPONENTS
import ModalStatic from '../../components/ModalStatic';
import Input from '../../components/Form/Input';
import Select from '../../components/Form/Select';
import Alert from '../../helpers/Alert';
import ReactPaginate from 'react-paginate';
import { Form, Table, Row, Col } from 'react-bootstrap';

// SERVICES
import { addUser, getUsers, updateUser } from '../../services/UserService';

interface TypeNewUser {
  name: string;
  email: string;
  role: string;
}


export default function TableUsers() {

  const [users, setUsers] = useState<any[]>();
  const [newUser, setNewUser] = useState<TypeNewUser>({ name: '', email: '', role: '' });

  const [time, setTime] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [search, setSearch] = useState<string>('');



  useEffect(() => {
    getListUsers();
  }, [])


  const getListUsers = () => {
    // quantidade de usuarios
    const user: any = localStorage.getItem('user');
    const { time } = JSON.parse(user);

    time && setTime(time)
    getUsers('').then(res => {
      const data = res.data.rows;
      console.log(data.length)
      setUsers(data);
      setFilteredData(data)
    })
      .catch(err => { })
  }

  // filtra de acordo com pesquisa
  const filterList = (event: ChangeEvent<HTMLFormElement>) => {
    const { value } = event.target;
    setSearch(value);

    const newList = users?.filter((item) => JSON.stringify(item).toLowerCase().indexOf(value.toLowerCase()) !== -1);

    if (newList && newList.length > 0)
      setFilteredData(newList)

  }


  // atualiza o status do usuario
  const updateStatusUser = async (status: boolean, id: string) => {
    await updateUser({ id, status })
    getListUsers();
  }


  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setNewUser({ ...newUser, [name]: value });
  };

  const handleSelectChange = (name: string, value: any) => {
    setNewUser({ ...newUser, [name]: value });
  }

  const handleSubmitNewUser = (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    setNewUser({ name: '', email: '', role: '' });
    addUser(newUser.name, newUser.email, newUser.role)
      .then((res) => {
        getListUsers();
        Alert(true, 'Cadastrado Realizado! ');
      })
      .catch((err) => {
        Alert(false, 'Não foi possível realizar o cadastro');
      });
  }

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <h3 className='mt-3 ms-1'>Espaço de trabalho - {time}</h3>
        </div>
        <div className="col-md-6">

          <ModalStatic
            title='Convidar membro para o time'
            textButton='Convidar membro'
          >
            <Form onSubmit={handleSubmitNewUser} >
              <Input
                name="name"
                label="Nome"
                type="text"
                placeholder={'Digite seu nome'}
                data={newUser.name}
                setData={handleInputChange}
                required={true}
              />
              <Input
                name="email"
                label="E-mail"
                type="email"
                placeholder={'email@email.com'}
                data={newUser.email}
                setData={handleInputChange}
                required={true}
              />
              <Select
                title="Permissão"
                data={[
                  { _id: 'admin', name: 'Admin' },
                  { _id: 'manager', name: 'Manager' },
                  { _id: 'team member', name: 'Team member' },
                  { _id: 'viewer', name: 'Viewer' }
                ]}
                value={newUser?.role || ''}
                setSelected={(value: string) => { handleSelectChange('role', value) }}
              />
              <button className='btn btn-primary' type="submit">convidar</button>
            </Form>
          </ModalStatic>

        </div>
      </div>
      <div className="container-box d-block position-relative mt-3 ">

        <div className="row">
          <div className="col-md-6">

            <div className="filter-os">
              <FaSearch className="fa-search"></FaSearch>
              <input type="text" placeholder={i18n.t<string>('processes.search')} value={search}
                onChange={(event: any) => filterList(event)}
              />
            </div>
          </div>
        </div>
        <div className="col-md-12 pt-4">

          <DataTable

            noDataComponent="Sem informações para serem exibidas"
            striped
            customStyles={customStyles}
            pagination
            fixedHeader
            theme="solarized"
            paginationComponentOptions={{
              rowsPerPageText: 'Registros por página',
              rangeSeparatorText: 'de',
              selectAllRowsItem: true,
              selectAllRowsItemText: 'Todos',
            }}
            columns={[

              {
                name: 'NOME',
                sortable: true,
                selector: (row?: any) => row?.name || '',
              },
              {
                name: 'E-MAIL',
                sortable: true,
                width: '300px',
                selector: (row?: any) => row?.email || '',
              },
              {
                name: 'PERMISSÃO',
                sortable: true,
                selector: (row?: any) => row.role || '',
              },
              {
                name: 'STATUS',
                sortable: true,
                selector: (row?: any) => row.status ? 'Ativo' : 'Inativo',
              }, {
                name: '',
                sortable: true,
                cell: (row?: any) =>
                  <button
                    className={`${row.status ? 'btn-danger-outline' : 'btn-success-outline'} color-black me-2 export-data`}
                    onClick={() => { updateStatusUser(!row.status, row.id) }}
                  >
                    {row.status ? 'Desativar' : 'Ativar'}
                  </button>,
              }
            ]
            }
            data={filteredData}
          />
        </div>
      </div >
    </>
  )
}
